import { TextField } from '@warp-ds/react';
import React from 'react';
import { useInputMask } from './useInputMask';

type RangeInputProps = {
    ariaLabel?: string;
    helpText?: string;
    invalid: boolean;
    name: string;
    onChange?: (name: string, value: string) => void;
    value: string;
};

export function RangeInput(props: RangeInputProps) {
    const { ariaLabel, helpText, invalid, name, onChange, value } = props;

    const { inputRef, maskedValue, setMaskedValue, unmaskedValue } =
        useInputMask(value);

    React.useEffect(() => {
        onChange && onChange(name, unmaskedValue);
    }, [name, onChange, unmaskedValue]);

    const handleMaskedValue = React.useCallback(
        (ev: React.FormEvent<HTMLInputElement>) => {
            const { value } = ev.target as HTMLInputElement;
            setMaskedValue(value);
        },
        [setMaskedValue],
    );

    return (
        <TextField
            aria-label={ariaLabel}
            helpText={helpText}
            inputMode="numeric"
            invalid={invalid}
            maxLength={11}
            name={name}
            onInput={handleMaskedValue}
            pattern="[\d\s]+"
            ref={inputRef}
            value={maskedValue}
        />
    );
}
